import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule } from '@spartacus/core';
import { GlobalMessageComponentModule, IconModule, MediaModule } from '@spartacus/storefront';
import { ResetPasswordComponent } from './reset-password.component';
@NgModule({
  imports: [
    CommonModule,
    GlobalMessageComponentModule,
    I18nModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    RouterModule,
    IconModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ResetPasswordComponent: {
          component: ResetPasswordComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
    ResetPasswordComponent,
  ],
})
export class ResetPasswordModule {}
